import React, { useState } from "react";
import { useLanguage } from "./LanguageContext";

const CareersForm = () => {
  const [status, setStatus] = useState("Apply");
  const { currentLanguage } = useLanguage();

  // Add a fallback to "en" in case currentLanguage is undefined
  const t = (key) => {
    const dict = {
      sending: {
        en: "Sending...",
        fr: "Envoi en cours...",
        de: "Wird gesendet...",
        es: "Enviando...",
      },
      apply: {
        en: "Apply",
        fr: "Postuler",
        de: "Bewerben",
        es: "Aplicar",
      }
    };

    // Ensure that currentLanguage is valid, default to "en" if not.
    const language = currentLanguage || "en";

    return dict[key] && dict[key][language] ? dict[key][language] : dict[key]["en"];
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    const formData = new FormData();
    formData.append("firstName", e.target.elements.firstName.value);
    formData.append("lastName", e.target.elements.lastName.value);
    formData.append("email", e.target.elements.email.value);
    formData.append("phone", e.target.elements.phone.value);
    formData.append("portfolio", e.target.elements.portfolio.value);
    formData.append("message", e.target.elements.message.value);
    formData.append("resume", e.target.elements.resume.files[0]);

    try {
      const response = await fetch("http://localhost:5000/careers", {
        method: "POST",
        body: formData,
      });

      setStatus("apply");
      const result = await response.json();
      alert(result.status);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <form action="./mailer.php" method="POST">
      <div className="careers-form-header-container">
        <span>
          {
            {
              en: "We'd love to hear from you",
              fr: "Nous serions ravis d'avoir de vos nouvelles",
              de: "Wir würden uns freuen, von Ihnen zu hören",
              es: "Nos encantaría saber de ti",
            }[currentLanguage || "en"]
          }
        </span>
      </div>
      <div className="form-input-container">
        <div className="singular-input-container">
          <label htmlFor="firstName">
            {
              {
                en: "First Name",
                fr: "Prénom",
                de: "Vorname",
                es: "Nombre",
              }[currentLanguage || "en"]
            }
          </label>
          <input type="text" id="firstName" name="firstName" required />
        </div>
        <div className="singular-input-container">
          <label htmlFor="lastName">
            {
              {
                en: "Last Name",
                fr: "Nom de famille",
                de: "Nachname",
                es: "Apellido",
              }[currentLanguage || "en"]
            }
          </label>
          <input type="text" id="lastName" name="lastName" required />
        </div>
      </div>
      <div className="form-input-container">
        <div className="singular-input-container">
          <label htmlFor="email">
            {
              {
                en: "Email",
                fr: "Email",
                de: "E-Mail",
                es: "Correo electrónico",
              }[currentLanguage || "en"]
            }
          </label>
          <input type="email" id="email" name="email" required />
        </div>
        <div className="singular-input-container">
          <label htmlFor="phone">
            {
              {
                en: "Phone Number",
                fr: "Numéro de téléphone",
                de: "Telefonnummer",
                es: "Número de teléfono",
              }[currentLanguage || "en"]
            }
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            pattern="[0-9]{10}"
            required
          />
        </div>
      </div>
      <div className="form-input-container-full">
        <label htmlFor="message">
          {
            {
              en: "Supporting Text",
              fr: "Texte de soutien",
              de: "Zusätzliche Informationen",
              es: "Texto de apoyo",
            }[currentLanguage || "en"]
          }
        </label>
        <textarea id="message" name="message" required></textarea>
      </div>
      <div className="submit-button-container">
        <button className="cta-button-large-careers" type="submit">
          {t(status.toLowerCase())}
        </button>
      </div>
      <input type="hidden" name="subject" />
    </form>
  );
};

export default CareersForm;


{
  /* <div className="form-input-container-full">
        <label htmlFor="portfolio">
          Portfolio
        </label>
        <input type="url" id="portfolio" name="portfolio" />
      </div>
      <div className="form-resume-container">
        <label htmlFor="resume">
          Resume 
        </label>
        <input
          className="resume-input"
          type="file"
          id="resume"
          name="resume"
          accept=".pdf"
          required // Add required attribute for validation
        />
        <p className="resume-guideline">Upload PDF only (max 5MB)</p>
      </div> */
}
